export default "__VITE_ASSET__CTPJ2xwm__"